import React from 'react';
import ReactDOM from 'react-dom';
import HelpComponent from './HelpComponent';

class Surveying extends React.Component{
    constructor(){
        super();
        this.closeCard = this.closeCard.bind(this);
        this.typeChange = this.typeChange.bind(this);
        this.surveyingStart = this.surveyingStart.bind(this);
        this.surveyingClear = this.surveyingClear.bind(this);
        this.measureCompleted = this.measureCompleted.bind(this);
        this.state = {
            type:[
                "面積",
                "地表長度",
                "平面長度",
                "空間長度",
                "高度"
            ],
            changeType:"",
            completed:""
        };
    }
    componentWillMount(){
        window.main.OView.addEventListener("MeasureCompleted",this.measureCompleted);
        this.setState({changeType:"面積"});
    }
    componentWillUnmount(){
        window.main.OView.removeEventListener("MeasureCompleted",this.measureCompleted);
    }
    measureCompleted(e){
        if(!e.success){
            this.setState({changeType:""});
            return;
        }else{
            if(this.state.changeType==="面積"){
                let area = "";
                if(e.area >= 1000000)
                    area = (e.area / 1000000).toFixed(3) + "    平方公里";
                else
                    area = e.area.toFixed(3) + "    平方公尺";
                this.setState({completed:area});
            }else if(this.state.changeType==="地表長度"){
                let length = "";
                if(e.length >= 1000)
                    length = (e.length / 1000).toFixed(3) + "    公里";
                else
                    length = e.length.toFixed(3) + "    公尺";
                this.setState({completed:length});
            }else if(this.state.changeType==="平面長度"){
                let length = "";
                if(e.length >= 1000)
                    length = (e.length / 1000).toFixed(3) + "    公里";
                else
                    length = e.length.toFixed(3) + "    公尺";
                this.setState({completed:length});
            }else if(this.state.changeType==="空間長度"){
                let length = "";
                if(e.length >= 1000)
                    length = (e.length / 1000).toFixed(3) + "    公里";
                else
                    length = e.length.toFixed(3) + "    公尺";
                this.setState({completed:length});
            }else if(this.state.changeType==="高度"){
                let height = "";
                if(e.height >= 1000)
                    height = (e.height / 1000).toFixed(3) + "    公里";
                else
                    height = e.height.toFixed(3) + "    公尺";
                this.setState({completed:height});
            }
        }
    }
    typeChange(event){
        switch(event.target.value){
            case "面積": 
                this.setState({changeType:"面積"});
                break;
            case "地表長度":
                this.setState({changeType:"地表長度"});
                break;
            case "平面長度":
                this.setState({changeType:"平面長度"});
            break;
            case "空間長度":
                this.setState({changeType:"空間長度"});
                break;
            case "高度":
                this.setState({changeType:"高度"});
                break;
            default:
                break;
        }
    }
    surveyingStart(){
        switch(this.state.changeType){
            case "面積": 
                window.main.OView.abortMeasure();
                window.alertify.log("左鍵新增節點，雙擊左建結束測量");
                window.main.OView.measureArea();
                break;
            case "地表長度":
                window.main.OView.abortMeasure();
                window.alertify.log("左鍵新增節點，雙擊左建結束測量");
                window.main.OView.measureSurfaceLength();
                break;
            case "平面長度":
                window.main.OView.abortMeasure();
                window.alertify.log("左鍵新增節點，雙擊左建結束測量");
                window.main.OView.measure2DLength();
                break;
            case "空間長度":
                window.main.OView.abortMeasure();
                window.alertify.log("左鍵新增節點，雙擊左建結束測量");
                window.main.OView.measureSpatialLength();
                break;
            case "高度":
                window.main.OView.abortMeasure();
                window.alertify.log("左鍵開始測量");
                window.main.OView.measureHeight();
                break;
            default:
                break;
        } 
    }
    surveyingClear(){
        window.main.OView.clearMeasure();
        this.setState({completed:""});
    }
    closeCard(){
        this.props.setSurveyingOpen();
    }
    onHelpClick(mode){
        this.setState({helpMode:!this.state.helpMode})
    }
    render(){
        const type = this.state.type;
        if(this.state.helpMode){
            switch(this.state.changeType){
                case "面積":
                    ReactDOM.render(<HelpComponent videoSrc="https://www.youtube.com/embed/JvRg6F43bdA" onHelpClick={(e)=>this.onHelpClick(e)} />,document.getElementById('Help')); 
                    break;
                case "地表長度":
                    ReactDOM.render(<HelpComponent videoSrc="https://www.youtube.com/embed/zxnNtWnBpMo" onHelpClick={(e)=>this.onHelpClick(e)} />,document.getElementById('Help')); 
                    break;
                case "平面長度":
                    ReactDOM.render(<HelpComponent videoSrc="https://www.youtube.com/embed/ypsgpHw5JKE" onHelpClick={(e)=>this.onHelpClick(e)} />,document.getElementById('Help')); 
                    break;
                case "空間長度":
                    ReactDOM.render(<HelpComponent videoSrc="https://www.youtube.com/embed/EFT5jJck5PA" onHelpClick={(e)=>this.onHelpClick(e)} />,document.getElementById('Help')); 
                    break;
                case "高度":
                    ReactDOM.render(<HelpComponent videoSrc="https://www.youtube.com/embed/sHw2EAt_vI8" onHelpClick={(e)=>this.onHelpClick(e)} />,document.getElementById('Help')); 
                    break;
                default:
                    break;
            }
        }
        else{
            ReactDOM.unmountComponentAtNode(document.getElementById('Help'));
        }
        
        return(
            <div className="ts card" id="surveying" style={{zIndex:"100"}}>
                <div className="extra content">
                    <div className="actions">
                        <div className="ts separated icon buttons">
                            <button className="ts circular icon button" onClick={this.closeCard.bind(this)}>
                                <i className="remove icon"></i>
                            </button>
                        </div>
                    </div>
                    <div className="header">
                        <i className="crop icon"></i>
                        測量功能
                    </div>
                    <div className="meta">
                        <div>
                            選定功能後點擊開始
                        </div>
                    </div>
                </div>
                <div className="content">
                    <div className="ts grid">
                        <div className="row" id="surveyingRow">
                            <div className="eight wide column">
                                <select className="ts borderless basic dropdown" onChange={(e)=>this.typeChange(e)}>
                                    {
                                        type.map(
                                            (name)=>
                                            <option name={name}>
                                                {name}
                                            </option>
                                        )
                                    }
                                </select> 
                                <button className="ts circular pulsing mini icon button" style={{fontSize:"8px"}} onClick={(e)=>this.onHelpClick(this.state.changeType)}>
                                    <i className="help small icon" style={{color:"#919191"}}></i>
                                </button>                     
                            </div>
                            <div className="eight wide column" id="surveyingStart">
                                <div className="ts separated icon buttons">
                                    <button className="ts circular icon button" onClick={(e)=>this.surveyingStart(e)}>
                                        <i className="checkmark icon"></i>
                                        開始
                                    </button>
                                    <button className="ts circular icon button" onClick={(e)=>this.surveyingClear(e)}>
                                        <i className="trash outline icon"></i>
                                        清除
                                    </button>
                                </div>                                                  
                            </div>
                        </div>
                    </div>    
                    <div id="surveyingEnd">
                        <h4>{this.state.completed}</h4>
                    </div>
                </div>
            </div>            
        );
    }
}
export default Surveying